var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"content","fluid":""}},[(_vm.currentState === 'AUTHENTIFICATION')?_c('Authentification'):(_vm.currentState === 'MOBILE')?_c('MobileGesture'):_c('Kernel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }